module.exports = __webpack_public_path__ + "img/needs-signature.71078d6d.svg";